import PopDown from '@/components/PopDown.vue';

export default {
    components: {
        PopDown,
    },
    data() {
        return {
            pop: {
                active: false,
                message: null,
                timer: null,
                className: null,
            },
        };
    },
    beforedestroy() {
        clearTimeout(this.pop.timer);
    },
    methods: {
        popOpen(message, className = null) {
            clearTimeout(this.pop.timer);
            this.pop.active = true;
            this.pop.message = message;
            this.pop.timer = setTimeout(this.popClose, 5000);
            this.pop.className = className;
        },
        popClose() {
            clearTimeout(this.pop.timer);
            this.pop.active = false;
            this.pop.message = null;
            this.pop.timer = null;
            this.pop.className = null;
        },
    },
};
